import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import {
  AccountancySoftwareListResponse,
  IPaginatedRequest,
  POSTAccountancySoftwareBody,
  POSTAccountancySoftwareResponse,
  PUTAccountancySoftwareBody,
  PUTAccountancySoftwareResponse
} from '@cbgms/api'

export const loadAccountancySoftware = (params: IPaginatedRequest = {}) =>
  AsyncAction<AccountancySoftwareListResponse>({
    type: [types.LOAD_ACCOUNTANCY_SOFTWARE, types.LOAD_ACCOUNTANCY_SOFTWARE_SUCCESS, types.LOAD_ACCOUNTANCY_SOFTWARE_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'GET',
        url: '/modules/accountancy-software',
        params
      }
    }
  })

export const updateAccountancySoftware = (UUID: string, body: PUTAccountancySoftwareBody) =>
  AsyncAction<PUTAccountancySoftwareResponse>({
    type: [types.UPDATE_ACCOUNTANCY_SOFTWARE, types.UPDATE_ACCOUNTANCY_SOFTWARE_SUCCESS, types.UPDATE_ACCOUNTANCY_SOFTWARE_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'PUT',
        url: `/modules/accountancy-software/${UUID}`,
        data: body
      }
    }
  })

export const createAccountancySoftware = (body: POSTAccountancySoftwareBody) =>
  AsyncAction<POSTAccountancySoftwareResponse>({
    type: [types.CREATE_ACCOUNTANCY_SOFTWARE, types.CREATE_ACCOUNTANCY_SOFTWARE_SUCCESS, types.CREATE_ACCOUNTANCY_SOFTWARE_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'POST',
        url: '/modules/accountancy-software',
        data: body
      }
    }
  })
